/**
 * Formats date string to yyyy-mm-dd
 *
 * @param dateToConvert a string that is convertable to a date or a Date object
 * @returns String in format yyyy-mm-dd
 */
export function formatDate(dateToConvert: string | Date) {
  const date = new Date(dateToConvert);
  const day = `0${date.getDate()}`.slice(-2);
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
}
